if (typeof window.globalCartState === 'undefined') {
  window.globalCartState = {};

  window.updateGlobalCartState = function (cart) {
    window.globalCartState = {};
    if (cart && cart.items) {
      cart.items.forEach((item) => {
        window.globalCartState[item.variant_id] = item.quantity;
      });
    }
    document.querySelectorAll('product-form').forEach((form) => {
      if (typeof form.updateButtonForLimit === 'function') {
        form.updateButtonForLimit();
      }
    });
  };

  window.fetchGlobalCartState = async function () {
    try {
      const cartUrl = window.routes?.cart_url || '/cart';
      const response = await fetch(`${cartUrl}.js`);
      const cart = await response.json();
      window.updateGlobalCartState(cart);
    } catch (e) {
      console.error('Error fetching cart state:', e);
    }
  };

  // Fetch initial cart state
  window.fetchGlobalCartState();

  // Listen to cart update event
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      window.fetchGlobalCartState();
    });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (typeof subscribe === 'function') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          window.fetchGlobalCartState();
        });
      }
    });
  }
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.variantIdInput) {
          this.variantIdInput.addEventListener('change', this.updateButtonForLimit.bind(this));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const cartQty = window.globalCartState ? (window.globalCartState[variantId] || 0) : 0;
        const enteredQty = parseInt(formData.get('quantity') || '1');
        
        let qtyToAdd = enteredQty - cartQty;
        if (cartQty === 0 && enteredQty > 0) {
          qtyToAdd = enteredQty;
        }

        if (qtyToAdd < 0) {
          const configChange = fetchConfig('javascript');
          configChange.headers['X-Requested-With'] = 'XMLHttpRequest';
          configChange.body = JSON.stringify({
            id: variantId.toString(),
            quantity: enteredQty,
            sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [],
            sections_url: window.location.pathname
          });
          
          fetch(`${window.routes?.cart_change_url || '/cart/change.js'}`, configChange)
            .then((response) => response.json())
            .then((response) => {
              if (this.cart) {
                this.cart.renderContents(response);
              }
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              });
            })
            .catch((e) => console.error(e))
            .finally(() => {
              this.submitButton.classList.remove('loading');
              this.querySelector('.loading__spinner').classList.add('hidden');
              this.submitButton.removeAttribute('aria-disabled');
            });
          return;
        }

        if (qtyToAdd === 0) {
          if (this.cart) {
            this.cart.open();
          }
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');
          this.submitButton.removeAttribute('aria-disabled');
          return;
        }

        formData.set('quantity', qtyToAdd);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const paymentButton = this.querySelector('.shopify-payment-button, .shopify-payment-button-wrapper');
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          if (paymentButton) {
            paymentButton.style.display = 'none';
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          if (paymentButton) {
            paymentButton.style.display = '';
          }
        }
      }

      connectedCallback() {
        this.updateButtonForLimit();
      }

      updateButtonForLimit() {
        const variantId = this.variantIdInput?.value;
        if (!variantId) return;

        const cartQty = window.globalCartState ? (window.globalCartState[variantId] || 0) : 0;

        // Sync PDP quantity selector value and bounds
        const quantityInput = this.closest('product-info')?.querySelector('.quantity__input') || document.getElementById(`Quantity-${this.dataset.sectionId}`);
        if (quantityInput) {
          quantityInput.dataset.cartQuantity = cartQty;
          quantityInput.setAttribute('data-cart-quantity', cartQty);
          
          let qtyMin = parseInt(quantityInput.dataset.min || '1');
          let qtyMax = 6;
          let qtyValue = qtyMin;
          
          if (cartQty >= 6) {
            qtyValue = 6;
            qtyMin = 1;
            qtyMax = 6;
          } else if (cartQty > 0) {
            qtyValue = cartQty;
            qtyMin = 1;
          } else {
            qtyValue = 1;
            qtyMin = 1;
          }
          
          quantityInput.min = qtyMin;
          quantityInput.max = qtyMax;
          quantityInput.setAttribute('min', qtyMin);
          quantityInput.setAttribute('max', qtyMax);
          quantityInput.value = qtyValue;
          
          const quantityInputWrapper = quantityInput.closest('quantity-input');
          if (quantityInputWrapper && typeof quantityInputWrapper.validateQtyRules === 'function') {
            quantityInputWrapper.validateQtyRules();
          }
        }

        // Sync rules indicator "(6 in cart)" and limit warning message
        const rulesCart = this.closest('product-info')?.querySelector('.quantity__rules-cart');
        if (rulesCart) {
          rulesCart.classList.toggle('hidden', cartQty === 0);
          const qtyCartSpan = rulesCart.querySelector('.quantity-cart');
          if (qtyCartSpan) {
            qtyCartSpan.textContent = cartQty;
          }
        }
        
        const limitMsg = this.closest('product-info')?.querySelector('.quantity-limit-message');
        if (limitMsg) {
          limitMsg.classList.toggle('hidden', cartQty < 6);
        }

        if (cartQty >= 6) {
          if (this.submitButton) {
            if (!this.submitButton.hasAttribute('data-original-disabled')) {
              const initialDisabled = this.submitButton.hasAttribute('disabled');
              const initialText = this.submitButtonText ? this.submitButtonText.textContent.trim() : '';

              if (initialText.toLowerCase() === 'limit reached') {
                this.submitButton.setAttribute('data-original-disabled', 'false');
                this.submitButton.setAttribute('data-original-text', window.variantStrings?.addToCart || 'Add to Cart');
              } else {
                this.submitButton.setAttribute('data-original-disabled', initialDisabled ? 'true' : 'false');
                if (this.submitButtonText) {
                  this.submitButton.setAttribute('data-original-text', initialText);
                }
              }
            }

            this.submitButton.setAttribute('disabled', 'disabled');
            if (this.submitButtonText) {
              this.submitButtonText.textContent = window.variantStrings?.cartLimitReached || 'Limit Reached';
            }

            const paymentButton = this.querySelector('.shopify-payment-button, .shopify-payment-button-wrapper');
            if (paymentButton) {
              paymentButton.style.display = 'none';
            }
          }
        } else {
          if (this.submitButton) {
            const currentText = this.submitButtonText ? this.submitButtonText.textContent.trim().toLowerCase() : '';
            if (this.submitButton.hasAttribute('data-original-disabled') || currentText === 'limit reached') {
              const originalDisabled = this.submitButton.getAttribute('data-original-disabled') === 'true';
              if (originalDisabled) {
                this.submitButton.setAttribute('disabled', 'disabled');
              } else {
                this.submitButton.removeAttribute('disabled');
              }
              this.submitButton.removeAttribute('data-original-disabled');

              if (this.submitButtonText) {
                const originalText = this.submitButton.getAttribute('data-original-text') || window.variantStrings?.addToCart || 'Add to Cart';
                this.submitButtonText.textContent = originalText;
              }
              this.submitButton.removeAttribute('data-original-text');

              const paymentButton = this.querySelector('.shopify-payment-button, .shopify-payment-button-wrapper');
              if (paymentButton) {
                paymentButton.style.display = '';
              }
            }
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
